import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { user, login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => { if (user && user.email) navigate("/admin"); }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Login failed. Check your credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen flex items-center justify-center px-5 bg-background">
      <div className="w-full max-w-sm border border-border p-10 bg-card">
        <div className="w-12 h-12 bg-primary flex items-center justify-center mb-6"><Lock className="w-6 h-6 text-white" /></div>
        <h1 className="font-display text-3xl mb-1">Admin Access</h1>
        <p className="text-muted-foreground text-sm mb-8">Sign in to manage your site.</p>
        <form onSubmit={submit} className="space-y-4">
          <input data-testid="admin-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" className="w-full bg-secondary px-4 py-3 outline-none focus:ring-1 focus:ring-primary" />
          <input data-testid="admin-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" className="w-full bg-secondary px-4 py-3 outline-none focus:ring-1 focus:ring-primary" />
          {error && <p data-testid="admin-error" className="text-destructive text-sm">{error}</p>}
          <button data-testid="admin-login-btn" type="submit" disabled={loading} className="w-full bg-primary text-white py-3.5 font-semibold hover:bg-primary/90 active:scale-95 transition disabled:opacity-60">
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
